import React from "react";
import { useHistory } from "react-router-dom";
import { Center, Spinner } from "@chakra-ui/react";
import { useAuth } from "contexts/AuthContext";

interface Props {
  children: React.ReactNode;
}

export default function RequireAdmin({ children }: Props): JSX.Element | null {
  const { isAdmin, isInitializing } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (!isInitializing && !isAdmin) {
      history.replace("/auth/sign-in");
    }
  }, [isInitializing, isAdmin, history]);

  if (isInitializing || !isAdmin) {
    return (
      <Center h="100vh" w="100%">
        <Spinner size="xl" thickness="4px" color="brand.500" />
      </Center>
    );
  }

  return <>{children}</>;
}
